import AppSummaryPage from 'pages/AppSummary';
import EditPagePage from 'pages/EditPage';
import EditMenuPage from 'pages/EditMenu';
import EditMenuItemDependenciesPage from 'pages/EditMenuItemDependencies';
import EditSectionAttributesPage from 'pages/EditSectionAttributes';
import EditSectionPage from 'pages/EditSection';
import UniversalPage from 'pages/Universal';
import AssetsPage from 'pages/Assets';
import EditAssetPage from 'pages/EditAsset';
import DashboardPage from 'pages/DashboardPage';
import WebBuilder from 'pages/BuilderPage';
import EditLanguagePage from 'pages/EditLanguage';
import EditLayoutPage from 'pages/EditLayout';

const routes = [
  {
    name: 'AppSummary',
    route: '/app/:appId',
    component: <AppSummaryPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'WebBuilder',
    route: '/builder/:appId/build',
    component: <WebBuilder />,
  },
  {
    name: 'EditPage',
    route: '/app/:appId/page/:pageId?',
    component: <EditPagePage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditMenu',
    route: '/app/:appId/menu/:menuId?',
    component: <EditMenuPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditMenuItemDependency',
    route: '/app/:appId/menu/:menuId/menu-item-dependency/:menuItemDependencyId?/:action?',
    component: <EditMenuItemDependenciesPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditSection',
    route: '/app/:appId/page/:pageId/section/:sectionId?',
    component: <EditSectionPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditSection',
    route: '/section-attributes/:sectionId',
    component: <EditSectionAttributesPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'Assets',
    route: '/assets/',
    component: <AssetsPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditAsset',
    route: '/assets/edit/:fileId',
    component: <EditAssetPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'Dashboard',
    route: '/dashboard',
    component: <DashboardPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'Universal',
    route: '*',
    component: <UniversalPage />,
  },
  {
    name: 'EditLanguage',
    route: '/app/:appId/language/:languageId?',
    component: <EditLanguagePage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditLayout',
    route: '/app/:appId/layout/:layoutId?',
    component: <EditLayoutPage />,
    required: {
      auth: true,
    },
  },
];

export default routes;
